import { observable, computed, action } from 'mobx';
import { App, AppRegistry } from 'core';
import { TagsApp } from 'apps/tag/app';

import { IssueTrackerModel } from 'apps/issueTracker/models';
import { LabelsApp } from 'apps/issueTracker/apps/labelApp';

export class IssueTrackerApp extends App {
  static registryName = 'IssueTrackerApp';
  static AppProps = {
    labels: LabelsApp,
    tags: TagsApp,
  };

  static Model = IssueTrackerModel;
  @observable activeTab = 'open';

  @computed get labelsCount() {
    return this.labels.apps.length;
  }

  @computed get milestonesCount() {
    return 0;
  }

  @action SetActiveTab = tabName => {
    this.activeTab = tabName;
  };
}
AppRegistry.add(IssueTrackerApp);
